import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "conduit_token";
const SHADOW_TOKEN_KEY = "conduit_shadow_token"; // real admin's token, kept while masquerading

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

export const shadowTokenStore = {
  get: () => localStorage.getItem(SHADOW_TOKEN_KEY),
  set: (t) => localStorage.setItem(SHADOW_TOKEN_KEY, t),
  clear: () => localStorage.removeItem(SHADOW_TOKEN_KEY),
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // If we're inside a masquerade session and the impersonation token expired,
      // fall back to the real admin's token instead of forcing a full re-login.
      const shadow = shadowTokenStore.get();
      if (shadow) {
        tokenStore.set(shadow);
        shadowTokenStore.clear();
        window.location.reload();
        return Promise.reject(err);
      }
      tokenStore.clear();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
